import { render, staticRenderFns } from "./choice-hacking.vue?vue&type=template&id=74c12dbc&scoped=true&"
import script from "./choice-hacking.vue?vue&type=script&lang=js&"
export * from "./choice-hacking.vue?vue&type=script&lang=js&"
import style0 from "./choice-hacking.vue?vue&type=style&index=0&id=74c12dbc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c12dbc",
  null
  
)

export default component.exports